import * as React from 'react';
import { TextAlignProperty } from 'csstype';

interface HeadingProps {
  children: React.ReactNode;
  textAlign?: TextAlignProperty;
  className?: string;
  level?: 1 | 2 | 3 | 4;
}

export const Heading: React.FC<HeadingProps> = ({
  children,
  className = '',
  level = 2,
}) => {
  const headingClass = `font-semibold ${className}`;
  switch (level) {
    case 1:
      return <h1 className={headingClass}>{children}</h1>;
    case 2:
      return <h2 className={headingClass}>{children}</h2>;
    case 3:
      return <h3 className={headingClass}>{children}</h3>;
    case 4:
      return <h4 className={headingClass}>{children}</h4>;
  }
};
